import { logsSearchSchema } from "@papier/logs-contracts";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/templates/$templateSlug/logs")({
  validateSearch: logsSearchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/projects/$projectSlug/logs",
      params: { projectSlug: params.projectSlug },
      search,
    });
  },
});
